import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { fehClient } from '@integration/api-client/feh';

export const { actions: FehApiActions, effects: FehApiEffects } =
  generateNgrxServiceClient('FEH', fehClient);
